import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class CreateCustomerProfile {
    static buildRequest(pProfileObj) {
        let returnValue = null;
        try {
            let body = {
                "name": pProfileObj.agtName,
                "address": pProfileObj.address,
                "mobileNumber": pProfileObj.mobile,
                "alternativeNumber": pProfileObj.altNo,
                "emailid": pProfileObj.email,
                "docid": pProfileObj.regNo,
                "subagentType": pProfileObj.agtType.value
            };
            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_CREATE_CUSTOMER_PROFILE,
                "error in building body for CreateCustomerProfile",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.CREATE_CUSTOMER_PROFILE,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_CREATE_CUSTOMER_PROFILE,
                "error in getting Response from  CreateCustomerProfile",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}